import { UtilityText } from 'component/text';
import {
    InstanceManager,
    NewInstanceScreen,
    QuestionManager,
    Search,
    searchFilter,
    TopicManager,
    ViewAction,
} from 'feature/editorial-dash/question-topic-manager';
import { CLICK, component, demoFile, extend, INPUT, story, WITHIN } from 'system/demo';
import { t } from 'util/stdtypes';

demoFile('feature/editorial-dash/question-topic-manager');

const instanceList = [
    { key: 'a', name: 'Question A', from: 'u', time: Date.now() },
    { key: 'b', name: 'Question B', from: 'u', time: Date.now() },
];

const baseConfig = {
    instanceTopLeftWidgets: [],
    instanceTopRightWidgets: [],
    instanceBodyWidgets: [],
    instanceBottomLeftWidgets: [],
    instanceBottomRightWidgets: [],
    instanceFilters: [],
    newInstanceWidgets: [],
    newInstanceCreateBlockers: [],
    newInstanceCreators: [],
    newInstancePostCreateTriggers: [],
};

function DummyWidget({ instance }) {
    return <UtilityText testID={'widget-' + instance.key} text='Widget' />;
}

component('InstanceManager', InstanceManager, {
    args: { titleLabel: t('Questions'), instanceList, structureKey: 'question' },
    config: baseConfig,
});
component('NewInstanceScreen', NewInstanceScreen, {
    args: { structureKey: 'question' },
    config: baseConfig,
});

extend(
    'InstanceManager',
    'Search filter',
    InstanceManager,
    {
        args: { titleLabel: t('Questions'), instanceList, structureKey: 'question' },
        config: {
            ...baseConfig,
            instanceFilters: [{ component: Search, filter: searchFilter }],
            instanceTopRightWidgets: [ViewAction],
        },
        state: { sessionData: { search: '' } },
    },
    [story('Filter B', [INPUT('search', 'B')])],
);

extend(
    'NewInstanceScreen',
    'Create',
    NewInstanceScreen,
    {
        args: { structureKey: 'question' },
        config: {
            ...baseConfig,
            newInstanceCreators: [
                {
                    structureKey: 'question',
                    creator: async () => ({ key: 'c1' }),
                },
            ],
            newInstancePostCreateTriggers: [async () => {}],
        },
    },
    [story('Create item', [INPUT('name', 'New Question'), CLICK('Create question')])],
);

extend(
    'InstanceManager',
    'With widgets',
    InstanceManager,
    {
        args: { titleLabel: t('Questions'), instanceList: [instanceList[0]], structureKey: 'question' },
        config: {
            ...baseConfig,
            instanceTopLeftWidgets: [DummyWidget],
            instanceTopRightWidgets: [ViewAction],
            instanceBodyWidgets: [],
            instanceBottomLeftWidgets: [],
            instanceBottomRightWidgets: [],
        },
    },
    [story('Add', [CLICK('New question')]), story('View first', [CLICK('view')])],
);
